import React from 'react'
import PropTypes from 'prop-types'
import { compose, lifecycle, setPropTypes, withStateHandlers } from 'recompose'
import { memoize, uniqueId } from 'lodash'

let drawKey = 0

const getDrawKey = memoize(() => drawKey++)

const reanimator = Component => props => (
  <div key={getDrawKey(props.data)}>
    <Component {...props} />
  </div>
)

const withChart = ChartClass =>
  compose(
    setPropTypes({
      data: PropTypes.any.isRequired
    }),
    reanimator,
    withStateHandlers({
      id: uniqueId('__chart')
    }),
    lifecycle({
      componentDidMount () {
        const { data, id, disableValue } = this.props
        data.disableValue = disableValue
        const chartEl = document.getElementById(id)
        this.chart = new ChartClass(chartEl)
        this.chart.update(data)
      }
    })
  )

export default withChart
